import React from "react";
import { useSelector } from "react-redux";
import ConsentForm from "../../service-steps/pre-assessment/consent-form";
import SpecialPopulations from "../../service-steps/pre-assessment/special-populations";

const PreAssessment = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep === 0 ? 1 : currentSubStep;
    switch (subStep) {
      case 1:
        return <ConsentForm />;
      case 2:
        return <SpecialPopulations />;
    }
  };
  return renderStep();
};

export default PreAssessment;
